import React, { useState } from 'react';
import { Grid, Paper, Typography, withStyles } from '@material-ui/core';
import GoToCard from './GoToCard';
import { connect } from 'react-redux';
import {download} from '../sc-utilities/download.utils';
import { parseURL } from '../sc-utilities';
import CssBaseline from "@material-ui/core/CssBaseline";
import DownloadReportCard from './DownloadReportCard';
import config from "../../config/config";
import {snackActions} from "../sc-utilities/SnackBar";

const styles = theme => ({
    main: {
        width: "auto",
        display: "block", // Fix IE 11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(6))]: {
            width: 400,
            marginLeft: "auto",
            marginRight: "auto"
        }
    },
    paper: {
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
    },
    logo: {
        width: "250px",
        margin: "10px"
    },
    helpDeskStyle: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    gridBox: {
        marginTop: theme.spacing(8)
    }
});

const Shared = props => {
    const { isAuthenticated, classes, translations } = props;
    let searchParams = parseURL(window.location.search) ? parseURL(window.location.search) : {Type: ''};
    const [redirectOptions, setRedirectOptions] = useState({ path: null });

    const handleDownload = async () => {
        const objectURL = `${config.backend_domain}:${config.backend_port}/shared/download?Hash=${searchParams.ID ? searchParams.ID  : null}`;
        let exportDataSuccessful = await download(objectURL);
        if (!exportDataSuccessful) {
            return snackActions.snackBarComponent(translations['download_error_msg'] || `Could not download file `, 'error');
        }
    }

    if (redirectOptions.path) {
        window.location.replace(redirectOptions.path);
    }

    return (
        <Paper className={classes.main}>
            <CssBaseline />
            <div className={classes.paper}>
                <img
                    alt="App logo"
                    className={classes.logo}
                    src={props.logoPath ? process.env.PUBLIC_URL + props.logoPath : process.env.PUBLIC_URL + "/assets/images/app-logo.svg"}
                />
                <Typography component="h1" variant="h6">
                    Shared
                </Typography>
                <Grid
                    className={classes.gridBox}
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    spacing={2}
                >
                    {isAuthenticated ? <Grid item>
                        <GoToCard setRedirectOptions={setRedirectOptions}/>
                    </Grid> : null}
                    <Grid item>
                        <DownloadReportCard downloadShared={handleDownload}/>
                    </Grid>
                </Grid>
            </div>
        </Paper>
    );
}
const mapStateToProps = state => {
    return {
        isAuthenticated: state.core.login.token !== null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles, { withTheme: true })(Shared))
